module.exports = __webpack_public_path__ + "img/xls.43f3c7ad.png";